import { Fragment, useMemo } from 'react';
import { Panel } from 'foundations-components/transitional/components/Panel';
import { PanelHeader } from 'foundations-components/transitional/components/PanelHeader';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import UITable from 'UIComponents/table/UITable';
import EditorShortcutLabel from 'automation-ui-canvas/components/flow-header/menu-bar/EditorShortcutLabel';
import { Map as ImmutableMap } from 'immutable';
import { flattenOptionsToList, getAllShortcutOptions } from 'automation-ui-canvas/components/flow-header/menu-bar/utils/menuItemUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShortcutsHelpPanel = ({
  flow,
  onClose,
  topLevelMenuOptions
}) => {
  const objectTypeId = flow.objectTypeId;
  const labelsByid = useMemo(() => {
    return topLevelMenuOptions.reduce((acc, option) => {
      return acc.set(option.id, option.getLabel({
        objectTypeId
      }));
    }, ImmutableMap());
  }, [topLevelMenuOptions, objectTypeId]);
  const shortcutsByCategory = useMemo(() => topLevelMenuOptions.reduce((acc, option) => {
    if (option.options) {
      const shortcutOptions = getAllShortcutOptions(flattenOptionsToList(option.options.flat()));
      return shortcutOptions.size ? acc.set(option.id, shortcutOptions) : acc;
    } else if ('shortcut' in option && option.shortcut) {
      return acc.set(option.id, ImmutableMap({
        [option.id]: option
      }));
    }
    return acc;
  }, ImmutableMap()), [topLevelMenuOptions]);
  return /*#__PURE__*/_jsxs(Panel, {
    width: 500,
    children: [/*#__PURE__*/_jsx(PanelHeader, {
      children: /*#__PURE__*/_jsxs(Text, {
        as: "h2",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.editorMenuBar.shortcutsPanel.title"
        }), /*#__PURE__*/_jsx(CloseButton, {
          onClick: onClose
        })]
      })
    }), /*#__PURE__*/_jsx(PanelBody, {
      children: shortcutsByCategory.map((options, categoryId) => {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h4",
            marginInline: "500",
            marginBlockStart: "500",
            marginBlock: "400",
            children: labelsByid.get(categoryId)
          }), /*#__PURE__*/_jsx(UITable, {
            condensed: true,
            bordered: false,
            children: /*#__PURE__*/_jsx("tbody", {
              children: options.valueSeq().toArray().map(option => /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  style: {
                    width: 250
                  },
                  children: option.getLabel({
                    objectTypeId: flow.objectTypeId
                  })
                }), /*#__PURE__*/_jsx("td", {
                  children: /*#__PURE__*/_jsx(EditorShortcutLabel, {
                    use: "table",
                    shortcut: option.shortcut
                  })
                })]
              }, option.id))
            })
          })]
        }, categoryId);
      }).toArray()
    })]
  });
};
export default ShortcutsHelpPanel;